module.exports = {
      id: "icon-quote-marks-usage",
      viewBox: "0 0 31 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-quote-marks",
      toString: function () {
        return this.url;
      }
    }